import { invokeApi } from "../../bl_libs/invokeApi";

export const students_list_api = async (signal = null) => {
  const requestObj = {
    path: `api/associates/students_list`,
    method: "GET",
    signal,
  };
  return invokeApi(requestObj);
};

export const active_students_list_api = async (signal = null) => {
  const requestObj = {
    path: `api/associates/active_students_list`,
    method: "GET",
    signal,
  };
  return invokeApi(requestObj);
};

export const add_student_api = async (data) => {
  const requestObj = {
    path: `api/students`,
    method: "POST",
    headers: {
      "Content-Type": "multipart/form-data",
    },
    postData: data,
  };
  return invokeApi(requestObj);
};

export const bulk_import_students_api = async (rows) => {
  const requestObj = {
    path: `api/students/bulk_import`,
    method: "POST",
    postData: { rows },
  };
  return invokeApi(requestObj);
};

export const change_student_password_api = async (student_id, data) => {
  const requestObj = {
    path: `api/students/change_password/${student_id}`,
    method: "POST",
    postData: data,
  };
  return invokeApi(requestObj);
};

export const manage_class_timings_api = async (data, student_id) => {
  const requestObj = {
    path: `api/students/manage_class_timings/${student_id}`,
    method: "PUT",
    postData: data,
  };
  return invokeApi(requestObj);
};

export const update_student_api = async (data, student_id) => {
  const requestObj = {
    path: `api/students/${student_id}`,
    method: "PUT",
    headers: {
      "Content-Type": "multipart/form-data",
    },
    postData: data,
  };
  return invokeApi(requestObj);
};

export const delete_student_api = async (student_id) => {
  const requestObj = {
    path: `api/students/${student_id}`,
    method: "DELETE",
  };
  return invokeApi(requestObj);
};

export const classes_list_by_student_api = async (student_id, signal = null) => {
  const requestObj = {
    path: `api/students/get_class_access/${student_id}`,
    method: "GET",
    signal,
  };
  return invokeApi(requestObj);
};

export const manage_classes_access_api = async (data, student_id) => {
  const requestObj = {
    path: `api/students/manage_class_access/${student_id}`,
    method: "PUT",
    postData: data,
  };
  return invokeApi(requestObj);
};

export const subjects_list_by_student_api = async (
  student_id,
  signal = null,
) => {
  const requestObj = {
    path: `api/students/get_subject_access/${student_id}`,
    method: "GET",
    signal,
  };
  return invokeApi(requestObj);
};

export const manage_subjects_access_api = async (data, student_id) => {
  const requestObj = {
    path: `api/students/manage_subject_access/${student_id}`,
    method: "PUT",
    postData: data,
  };
  return invokeApi(requestObj);
};

export const get_teachers_for_student_api = async (
  student_id,
  signal = null,
) => {
  const requestObj = {
    path: `api/students/get_teachers_for_student/${student_id}`,
    method: "GET",
    signal,
  };
  return invokeApi(requestObj);
};

export const manage_teachers_access_api = async (data, student_id) => {
  const requestObj = {
    path: `api/students/manage_teachers_access/${student_id}`,
    method: "PUT",
    postData: data,
  };
  return invokeApi(requestObj);
};

export const students_list_by_class_api = async (class_id, signal = null) => {
  const requestObj = {
    path: `api/students/get_students_for_class/${class_id}`,
    method: "GET",
    signal,
  };
  return invokeApi(requestObj);
};

export const manage_class_students_api = async (data, class_id) => {
  const requestObj = {
    path: `api/students/manage_class_students/${class_id}`,
    method: "PUT",
    postData: data,
  };
  return invokeApi(requestObj);
};
